import model from "@/mixins/model";

export default {
    mixins: [model],
    model() {
        return {
            lead: {},
            agent: null
        }
    },
    mounted() {

        this.fetch();
    },
    methods: {
        fetch() {

            return this.dispatch((resolve, reject) => {

                this.$http.request({ url: 'leads/:lead' })
                    .then((response) => {

                        this.model.lead = response.data.lead;
                        this.model.agent = response.data.agent;
                    })
                    .then(resolve)
                    .catch(reject);

            });


        },
    }
}